// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__3qc2K","amount":"Amount_amount__IAvES","tip":"Amount_tip__2aIZ3","tipHeader":"Amount_tipHeader__aNCUf","tipsWrap":"Amount_tipsWrap__3XMHV"};